import axios from 'axios';
import { SESSION_STORAGE_KEYS } from 'src/utils/constants';

const identityV2 = axios.create({
  responseType: 'json',
  headers: {
    Accept: 'application/json',
  },
});

identityV2.interceptors.request.use(function (request) {
  request.baseURL = process.env.NEW_USERS_SELF_API_URL + '/ums/v2';
  request.headers.Authorization = `Bearer ${sessionStorage.getItem(
    SESSION_STORAGE_KEYS.ACCESS_TOKEN
  )}`;
  return request;
});

export default { identityV2 };
